
import React from 'react';
import { Calendar, Download } from 'lucide-react';
import { Button } from '../../ui/button';
import { CardTitle, CardDescription } from '../../ui/card';

interface AttendanceReportHeaderProps {
  onExport: () => void;
}

const AttendanceReportHeader: React.FC<AttendanceReportHeaderProps> = ({ onExport }) => {
  return (
    <div className="flex justify-between items-center">
      <div>
        <CardTitle className="text-xl flex items-center">
          <Calendar className="mr-2 h-5 w-5" />
          Attendance Report
        </CardTitle>
        <CardDescription>
          View teacher attendance patterns
        </CardDescription>
      </div>
      <Button 
        variant="outline" 
        size="sm" 
        className="flex items-center"
        onClick={onExport}
      >
        <Download className="mr-2 h-4 w-4" />
        Export Report JPG
      </Button>
    </div>
  );
};

export default AttendanceReportHeader;
